// Aufbau der Config
// config = {
//     checks: {
//         checkSomething: {
//             score: Number,
//             enabled: Boolean,
//             ranges: [
//                 {
//                     range: [Number, Number],
//                     multiplier: Number (0.0-1.0),
//                     key: String
//                 },
//                 ...
//             ]
//         }
//     },
//     languageKeysDE: {
//         key: String
//     },
//     languageKeysEN: {
//         key: String
//     }
// }

export const defaultConfig = {
    checks: {
        checkTitle: {
            enabled: true,
            category: 'title',
            score: 70,
            ranges: [
                {
                    range: [71, null],
                    multiplier: 0.5,
                    key: 'too_long',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [60, 70],
                    multiplier: 1.0,
                    key: 'ideal'
                },
                {
                    range: [50, 59],
                    multiplier: 0.8,
                    key: 'too_short',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [1, 49],
                    multiplier: 0.5,
                    key: 'too_short',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [0, 0],
                    multiplier: 0.0,
                    key: 'missing'
                }
            ]
        },
        checkMetaDescription: {
            enabled: true,
            category: 'description',
            score: 70,
            ranges: [
                {
                    range: [161, null],
                    multiplier: 0.3,
                    key: 'too_long',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [156, 160],
                    multiplier: 0.8,
                    key: 'bit_too_long',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [150, 155],
                    multiplier: 1.0,
                    key: 'ideal'
                },
                {
                    range: [100, 149],
                    multiplier: 0.8,
                    key: 'too_short',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [1, 99],
                    multiplier: 0.8,
                    key: 'too_short',
                    resultTemplate: 'result_basic_range'
                },
                {
                    range: [0, 0],
                    multiplier: 0.0,
                    key: 'missing'
                }
            ]
        },
        checkImageAlt: {
            enabled: true,
            category: 'images',
            score: 70,
            ranges: [
                {
                    range: [0, 0],
                    multiplier: 1.0,
                    key: 'ideal'
                },
                {
                    range: [1, 1],
                    multiplier: 0.5,
                    key: 'single_error'
                },
                {
                    range: [2, null],
                    multiplier: 0.0,
                    key: 'multiple_errors',
                    resultTemplate: 'result_basic_number'
                }
            ]
        },
        checkImageTitle: {
            enabled: false,
            category: 'images',
            score: 25,
            ranges: [
                {
                    range: [0, 0],
                    multiplier: 1.0,
                    key: 'ideal'
                },
                {
                    range: [1, 1],
                    multiplier: 0.5,
                    key: 'single_error'
                },
                {
                    range: [2, null],
                    multiplier: 0.0,
                    key: 'multiple_errors',
                    resultTemplate: 'result_basic_number'
                }
            ]
        },
        checkCanonical: {
            enabled: true,
            category: 'canonical',
            score: 80,
            ranges: [
                {
                    range: [0, 0],
                    multiplier: 0.0,
                    key: 'missing'
                },
                {
                    range: [1, 1],
                    multiplier: 1.0,
                    key: 'ideal'
                }
            ]
        },
        checkRobotsIndex: {
            enabled: true,
            category: 'robots',
            score: 50,
            ranges: [
                {
                    range: [0, 0],
                    multiplier: 0.0,
                    key: 'missing'
                },
                {
                    range: [1, 1],
                    multiplier: 1.0,
                    key: 'ideal'
                }
            ]
        },
        checkRobotsFollow: {
            enabled: true,
            category: 'robots',
            score: 50,
            ranges: [
                {
                    range: [0, 0],
                    multiplier: 0.0,
                    key: 'missing'
                },
                {
                    range: [1, 1],
                    multiplier: 1.0,
                    key: 'ideal'
                }
            ]
        },
        checkLinks: {
            enabled: true,
            category: 'links',
            score: 40,
            ranges: [
                {
                    range: [2,null],
                    multiplier: 1.0,
                    key: 'ideal'
                },
                {
                    range: [0, 1],
                    multiplier: 0.0,
                    key: 'too_few'
                }
            ]
        }
    },
    languageKeys: {
        de: {
            general: {
                missing_key: "Language key fehlt: ",
                title: "SEO Status",
                total_score: "Gesamtwertung",
                result_basic_range: "ist: $current, ideal: $lower - $upper",
                result_basic_number: "$current"
            },
            categories: {
                title: "Seitentitel",
                description: "Meta description tag",
                images: "Image Attribute",
                canonical: "Canonical Link",
                robots: "Robots",
                links: "Links"
            },
            checkTitle: {
                title: "Seitentitel",
                description: "Hier wird die Länge des Seitentitels bewertet",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Seitentitel hat gute Länge",
                too_short: "Seitentitel ist zu kurz",
                missing: "Seitentitel fehlt",
                bit_too_long: "Seitentitel ist etwas zu lang",
                too_long: "Seitentitel ist zu lang",
                hover: "Sollte zwischen 55 und 65 Zeichen lang sein"
            },
            checkMetaDescription: {
                title: "Meta description",
                description: "Bewertet die Länge der \"description\"",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Meta Description hat gute Länge",
                too_short: "Meta Description ist zu kurz",
                missing: "Meta Description fehlt",
                bit_too_long: "Meta Description ist etwas zu lang",
                too_long: "Meta Description ist zu lang",
                hover: "Sollte zwischen 150 und 160 Zeichen lang sein"

            },
            checkImageAlt: {
                title: "Image Attribute",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Alle Bilder haben ein \"alt\"-Attribut",
                single_error: "Ein Bild hat kein \"alt\"-Attribut",
                multiple_errors: "Mehrere Bilder haben kein \"alt\"-Attribut"
            },
            checkImageTitle: {
                title: "Image Attribute",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Alle Bilder haben ein \"title\"-Attribut",
                single_error: "Ein Bild hat kein \"title\"-Attribut",
                multiple_errors: "Mehrere Bilder haben kein \"title\"-Attribut"
            },
            checkCanonical: {
                title: "Canonical Link",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Canonical link ist vorhanden",
                missing: "Canonical link fehlt"
            },
            checkRobotsIndex: {
                title: "Robots",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Meta robots ist auf index gesetzt",
                missing: "Meta robots ist nicht auf index gesetzt"
            },
            checkRobotsFollow: {
                title: "Robots",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Meta robots ist auf follow gesetzt",
                missing: "Meta robots ist nicht auf follow gesetzt"
            },
            checkLinks: {
                title: "Ausgehende/Interne Links",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Es sind ausreichend Links vorhanden",
                too_few: "Es sind zu wenige Links vorhanden"
            }
        },
        en: {
            general: {
                missing_key: "Missing language key: ",
                title: "SEO Status",
                total_score: "Total score",
                result_basic_range: "current: $current, ideal: $lower - $upper",
                result_basic_number: "$current"
            },
            categories: {
                title: "Page title",
                description: "Meta description tag",
                images: "Image attributes",
                canonical: "Canonical link",
                robots: "Robots",
                links: "Links"
            },
            checkTitle: {
                title: "Page title",
                description: "This evaluates the length of the page title",
                outside_of_range: "Value is outside of range",
                ideal: "Page title length is good",
                too_short: "Page title is too short",
                missing: "Page title is missing",
                bit_too_long: "Page title is a bit too long",
                too_long: "Page title is too long",
                hover: "Should be between 55 and 65 characters long",
                title: "Should be between 55 and 65 characters long"

            },
            checkMetaDescription: {
                title: "Meta description tag",
                outside_of_range: "Value is outside of range",
                ideal: "Meta description length is good",
                too_short: "Meta description is too short",
                missing: "Meta description is missing",
                bit_too_long: "Meta description is a bit too long",
                too_long: "Meta description is too long",
                hover: "Should be between 150 and 160 characters long"
            },
            checkImageAlt: {
                title: "Image attributes",
                outside_of_range: "Value is outside of range",
                ideal: "All images have the \"alt\" attribute",
                single_error: "One image is missing the \"alt\" attribute",
                multiple_errors: "Multiple images are missing the \"alt\"-attibute"
            },
            checkImageTitle: {
                title: "Image attributes",
                outside_of_range: "Value is outside of range",
                ideal: "All images have the \"title\" attribute",
                single_error: "One image is missing the \"title\" attribute",
                multiple_errors: "Multiple images are missing the \"title\"-attibute"
            },
            checkCanonical: {
                title: "Canonical link",
                outside_of_range: "Value is outside of range",
                ideal: "Canonical link exists",
                missing: "Canonical link is missing"
            },
            checkRobotsIndex: {
                title: "Robots",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Meta robots is set to index",
                missing: "Meta robots is not set to index"
            },
            checkRobotsFollow: {
                title: "Robots",
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "Meta robots is set to follow",
                missing: "Meta robots is not set to follow"
            },
            checkLinks: {
                outside_of_range: "Wert liegt außerhalb der festgelegten Grenzen",
                ideal: "There are enough links",
                too_few: "There are too few links"
            }
        }
    }
}
